import { render, staticRenderFns } from "./DepositMoneyStatus.vue?vue&type=template&id=457e4cc9&"
import script from "./DepositMoneyStatus.vue?vue&type=script&lang=js&"
export * from "./DepositMoneyStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports